import classNames from 'classnames'
import {
    ResolvedIcon,
    OpenIncidentIcon,
    AcknowledgedIcon,
    TriggeredIcon,
    InvestigatingIcon,
    IdentifiedIcon,
    MonitoringIcon
} from '../../../icons'
import {updateIncident} from '../../../stores/incident-management'

const MIN_ARRAY_LENGTH = 1

export const handleStatusUpdate = (
    incidentActions,
    allComponents,
    statusValue,
    checkedIncident,
    setCheckedIncidentsIds,
    teamId,
    dispatch,
    text
) => {
    const components = incidentActions?.length > 0
        ? incidentActions
            ?.filter(action => action?.type === text?.action_types_options?.trigger_statuspage_update)
            ?.flatMap(action =>
                action?.settings?.map(setting =>
                    allComponents?.find(component => component?.value === setting?.target?.id)
                )
            )
        : []

    const actionTypes = incidentActions?.map(action => action?.type) || []

    dispatch(updateIncident(
        checkedIncident?.id,
        {
            name: checkedIncident?.name,
            description: checkedIncident?.description,
            urgency: checkedIncident?.urgency,
            actions: actionTypes.map(type =>
                type === text?.action_types_options?.trigger_alerts
                    ? {type}
                    : {
                        type,
                        settings: components?.map(component => ({
                            status_page_id: component?.statuspage_id,
                            component_id: component?.value
                        }))
                    }
            ),
            assignees: checkedIncident?.assignees,
            status: statusValue
        },
        setCheckedIncidentsIds,
        teamId
    ))
}

export const getStatusIcons = (text) => ({
    [text.status_options.resolved.value]: <ResolvedIcon />,
    [text.status_options.open.value]: <OpenIncidentIcon />,
    [text.status_options.acknowledged.value]: <AcknowledgedIcon />,
    [text.status_options.triggered.value]: <TriggeredIcon />,
    [text.status_options.investigating.value]: <InvestigatingIcon />,
    [text.status_options.identified.value]: <IdentifiedIcon />,
    [text.status_options.monitoring.value]: <MonitoringIcon />
})

export const getStatusOptionsWithIcons = (text, hasClassName = false) => {
    const statusOptions = Object.values(text.status_options)
    const icons = getStatusIcons(text)

    return statusOptions.map((status) => ({
        label: (
            hasClassName ? <span className={classNames({
                'd-flex align-items-center gap-half': hasClassName
            })}>
                {icons[status.value]}
                {status.label}
            </span> :
                <>
                    {status.label}
                </>
        ),
        value: status.value
    }))
}

export const getActionButtonStatus = (checkedIncident, checkedIds, text) => {
    const triggerType = checkedIncident?.trigger_type
    return (
        checkedIds?.length !== MIN_ARRAY_LENGTH ||
    (triggerType !== text.trigger_types.manual.value &&
     triggerType !== text.trigger_types.webhook.value) ||
    checkedIncident?.status === text.status_options.resolved.value
    )
}
